<template>
  <div class="promo-design-inputs">
    <v-expansion-panels v-model="getPromoPanel" multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-title>Email Settings</v-expansion-panel-title>
        <v-expansion-panel-text>
          <div>
            <v-text-field
              v-model.trim="actions.rf_email_subject"
              label="Email Subject"
              persistentPlaceholder
              hideDetails
              variant="outlined"
              density="compact"
            />
            <RfInsertUserTrait
              :app="app"
              actionName="rf_email_subject"
              title="subject"
              :actions="actions"
            />
          </div>
          <div class="promo-fonts-size-input" style="padding: 15px 0 0">
            <v-text-field
              v-model.trim="actions.rf_widget_width"
              label="Email Container Width"
              persistentPlaceholder
              hideDetails
              variant="outlined"
              density="compact"
            />
            <v-text-field
              v-model.trim="actions.rf_settings_title_padding_top"
              label="Container Margin Top"
              persistentPlaceholder
              hideDetails
              variant="outlined"
              density="compact"
            />
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Email Header</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsCompanyLogo :app="app" :model="model" :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Hero Image</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionImageUpload :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Message</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionActionsTitleMessage :model="model" :actions="actions" :app="app" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>User Interaction</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfRetentionButtons :actions="actions" :model="model" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Email Footer</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <v-text-field
            v-model.trim="actions.rf_email_company_name"
            variant="outlined"
            density="compact"
            label="Company Name & Address"
            persistentPlaceholder
            required
            hideDetails
          />
          <div class="promo-fonts-size-input" style="padding: 15px 0">
            <v-text-field
              v-model.trim="actions.rf_email_footer_bgcolor"
              variant="outlined"
              density="compact"
              hideDetails
              label="Footer background"
              persistentPlaceholder
            />
            <v-text-field
              v-model.trim="actions.rf_email_footer_font_color"
              variant="outlined"
              density="compact"
              hideDetails
              label="Font color"
              persistentPlaceholder
              @blur="
                actions.rf_email_footer_font_color = extendHex(actions.rf_email_footer_font_color)
              "
            />
          </div>
          <div class="promo-design-group">
            <v-text-field
              v-model.trim="actions.rf_settings_privacy_policy_link"
              variant="outlined"
              density="compact"
              label="Privacy Policy Link"
              persistentPlaceholder
              placeholder="e.g.: http://company.com/pagename"
              hideDetails
              style="margin-bottom: 14px"
            ></v-text-field>
            <v-text-field
              v-model.trim="actions.rf_settings_tos_link"
              variant="outlined"
              density="compact"
              label="Unsubscribe Link"
              persistentPlaceholder
              hideDetails
              placeholder="e.g.: http://company.com/pagename"
            ></v-text-field>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>Background & Content Colors</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <div class="promo-fonts-size-input">
            <v-text-field
              v-model.trim="actions.rf_email_body_bgcolor"
              variant="outlined"
              density="compact"
              hideDetails
              label="Body background color"
              persistentPlaceholder
              @blur="actions.rf_email_body_bgcolor = extendHex(actions.rf_email_body_bgcolor)"
            />
            <v-text-field
              v-model.trim="actions.rf_email_content_bgcolor"
              variant="outlined"
              hideDetails
              density="compact"
              label="Container background color"
              persistentPlaceholder
              @blur="actions.rf_email_content_bgcolor = extendHex(actions.rf_email_content_bgcolor)"
            ></v-text-field>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-title>CSS</v-expansion-panel-title>
        <v-expansion-panel-text class="retention-config-segments">
          <RfPromoCustomCSS :actions="actions" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup>
import RfRetentionActionsTitleMessage from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsTitleMessage.vue";
import RfRetentionButtons from "@/components/RfPathCreate/RfRetentionActions/RfRetentionButtons.vue";
import RfRetentionImageUpload from "@/components/RfPathCreate/RfRetentionActions/components/RfRetentionImageUpload.vue";
import RfPromoCustomCSS from "@/components/RfPromotions/RfPromoCustomCSS.vue";
import RfInsertUserTrait from "@/components/RfPathCreate/RfRetentionActions/RfInsertUserTrait.vue";
import RfRetentionActionsCompanyLogo from "@/components/RfPathCreate/RfRetentionActions/RfRetentionActionsCompanyLogo.vue";
import { ref } from "vue";
import { extendHex } from "@/utils/colorHelpers";

defineProps(["actions", "model", "app"]);
const getPromoPanel = ref([0]);
</script>
